module.exports = __webpack_public_path__ + "static/roadmap-b6d3efc3715a27b6933f8a8d701eab7d.svg";